import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { ICONS } from '@shared/domain/icons';
import { forkJoin, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NewIconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private httpClient: HttpClient,
  ) {
    const requests: Observable<string | null>[] = ICONS.map(icon => {
      return this.httpClient.get(icon.link, { responseType: 'text' }).pipe(catchError(() => of(null)));
    });

    forkJoin(requests).subscribe(svgs => {
      svgs.forEach((svg, index) => {
        if (!svg) {
          return;
        }
        this.matIconRegistry.addSvgIconLiteral(ICONS[index].name, this.domSanitizer.bypassSecurityTrustHtml(svg));
      });
    });
  }
}
